import { StickableUIData } from "./stickableUIData";

export class AccordionUIData extends StickableUIData {
  
  public readonly TABS_COUNT = "tabsCount";
  
  get tabsCount(): number { return this.getInternalValue<number>(this.TABS_COUNT); }
  setTabsCount(tabsCount: number): this { return this.setInternalValue(this.TABS_COUNT, tabsCount); }

}